import React from "react";
import { Button } from "./button";

export default function HowItWorksModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center">
      <div className="bg-gray-900 text-white p-6 sm:p-8 w-[90vw] max-w-sm text-center rounded-2xl border-2 border-cyan-600 shadow-2xl">
        <h2 className="text-xl font-bold mb-4 text-cyan-400">How Regret Roulette Works</h2>
        <ul className="list-disc list-inside text-sm space-y-2">
          <li>You connect your wallet to start playing.</li>
          <li>Each spin costs <strong>100k $REGRET</strong>.</li>
          <li>The wheel is weighted: not all prizes are equally likely.</li>
          <li>Possible outcomes: token prizes, free spins, or total loss.</li>
          <li>If you win a prize, it’s sent to your wallet on-chain.</li>
          <li>Regret is guaranteed. Joy is optional.</li>
        </ul>
        <div className="mt-6 text-center">
          <Button
            onClick={onClose}
            className="bg-cyan-500 hover:bg-cyan-400 text-black font-bold px-4 py-2 rounded"
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
